import React from 'react';
import { ScaleStep } from './ScaleStep';
import { ScaleGradation } from './ScaleGradation';

interface propsInterface {
  values: number[][],
  methods: {
    convertDECtoHEX: (decimal: number) => string
  }
}

export const Geometric = React.memo<propsInterface>((props) => {
  return (
    <>
      <div className='p-app-scale-box'>
        <h2 className='u-heading-scale-title'>Geometric - step</h2>
        <ScaleStep 
          values={props.values} 
          methods={{
            convertDECtoHEX: props.methods.convertDECtoHEX
          }}
        />         
      </div>
      <div className='p-app-scale-box'>
        <h2 className='u-heading-scale-title'>Geometric - gradation</h2>
        <ScaleGradation 
          values={props.values} 
          methods={{
            convertDECtoHEX: props.methods.convertDECtoHEX
          }}
        />
      </div>
    </>
  )
});